import React, { useEffect, useState, useCallback } from "react";
import { Box, TextField, Button, Chip, Paper, CircularProgress } from "@mui/material";
import { ConfirmDialog } from "primereact/confirmdialog";
import { getServiceProviderOrders } from "../../Apiservices/Auth/servers/profileServer";
import "./ServiceProviderDashboard.css";
import ServicesList from "./ServicesList";
import CateringService from "./redesigncatering/Cateringservices";
import TentHouseService from "./TentHouseService";
import PriestManageServices from "./PriestManageServices";
import HelperProvider from "./helperprovider/HelperPriceManager";
import OrderItemCard from "./OrderItemCard";

function ManageOrdersTabContent({ onActiveTypeChange }) {
    const [providerOrders, setProviderOrders] = useState({ orders: [] });
    const [loading, setLoading] = useState(true);

    const fetchProviderOrders = useCallback(async () => {
        setLoading(true);
        try {
            const  result  = await getServiceProviderOrders();
            setProviderOrders({
                orders: result,
            });
            console.log(`Legth ${providerOrders.orders.length}`)
        } catch (error) {
            console.error("Failed to services:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchProviderOrders();
    }, [fetchProviderOrders]);

    return (
        <>
            <ConfirmDialog />
            {loading ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        width: "100%",
                        backgroundColor: "#transparent",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : providerOrders.orders.length > 0 ? (
                providerOrders.orders.map((order) => (
                    <OrderItemCard key={order.order_item_id} orderData={order} />
                ))
            ) : (
                // <Paper sx={{ p: 2, backgroundColor: "#f8f8f8" }}>
                <div>
                    <h4>No Services Available</h4>
                </div>
                // </Paper>
            )}
        </>
    );
}
export default ManageOrdersTabContent;
